module.exports = __webpack_public_path__ + "static/lance-cummings-156f94ce9ed00ac8eecf5c26101715fe.svg";